import { render, staticRenderFns } from "./DetailedSalesMain.vue?vue&type=template&id=44572c56&scoped=true&"
import script from "./DetailedSalesMain.vue?vue&type=script&lang=js&"
export * from "./DetailedSalesMain.vue?vue&type=script&lang=js&"
import style0 from "./DetailedSalesMain.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DetailedSalesMain.vue?vue&type=style&index=1&id=44572c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44572c56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VCol,VContainer,VDataTable,VDatePicker,VMenu,VOverlay,VProgressCircular,VRow,VSelect,VTextField})
